import { jsx as _jsx } from "react/jsx-runtime";
import "./Infra/Instrumentation";
import debounce from "debounce-promise";
import { createRoot } from "react-dom/client";
import { createHashRouter } from "react-router-dom";
import "reflect-metadata";
import { AppRouter } from "./AppRouter";
import { Container } from "./Container";
import { Environment } from "./Infra/Environment";
import { i18nextInit } from "./Infra/i18next";
import { routingPaths as initalRoutingPaths } from "./UI/RoutingPaths";
import { disableViewModelReattach, enableViewModelReattach } from "./UI/useViewModel";
import { loadHeap } from "./Infra/LoadHeap";
import { SmartAuthManager } from "./Logic/SmartAuthManager";
import { delayAndWait } from "healthex-common/utils";
import { createAnonymousUserIdIfNeeded } from "./Logic/AuthManager";
import { ClearAuthManager } from "./UI/ClearAuthManager";
import { SocialLoginAuthManager } from "./UI/SocialLoginAuthManager";
const viewModelReattach = true;
void (async function main() {
    var _a;
    createAnonymousUserIdIfNeeded();
    try {
        await Promise.race([loadHeap().then(() => "loaded"), delayAndWait(3000).then(() => "timeout")]);
    }
    catch (error) {
        console.error("Error loading heap", error);
    }
    const heapSessionId = (_a = window.heap) === null || _a === void 0 ? void 0 : _a.getSessionId();
    if (heapSessionId !== null && heapSessionId !== undefined && typeof (newrelic === null || newrelic === void 0 ? void 0 : newrelic.setCustomAttribute) === "function") {
        newrelic.setCustomAttribute("heapSessionId", heapSessionId);
    }
    if (checkSubdomainRedirect())
        return;
    const embedded = false;
    const isSmartLaunch = false;
    const clearAuthResult = ClearAuthManager.checkAndReturnClearAuthResponse();
    if (clearAuthResult !== null && !window.location.hash) {
        window.location.replace(`${window.location.origin}/#/clear-ial2-callback${window.location.search}`);
        return;
    }
    const socialLoginAuthResponse = SocialLoginAuthManager.checkAndReturnSocialLoginAuthResponse();
    if (socialLoginAuthResponse && !window.location.hash) {
        window.location.replace(`${window.location.origin}/#/social-login-callback${window.location.search}`);
        return;
    }
    const isFastenRedirect = SmartAuthManager.checkForFastenRedirectCode();
    if (isFastenRedirect && !window.location.hash) {
        window.location.replace(`${window.location.origin}/#/fasten-callback${window.location.search}`);
        return;
    }
    if (!(await checkValidEmbedIfNeeded(embedded, isSmartLaunch))) {
        const root = document.getElementById("root");
        if (root)
            root.innerText = "You cannot view this page";
        return;
    }
    i18nextInit();
    const container = new Container({ embedded, isSmartLaunch });
    window.container = container;
    const rootEl = document.getElementById("root");
    if (!rootEl)
        return;
    const renderAtRoot = (routingPaths) => {
        document.querySelectorAll("body > .MuiModal-root").forEach((node) => node.remove());
        const root = createRoot(rootEl);
        root.render(_jsx(AppRouter, { container: container, routingPaths: routingPaths, routerFactory: createHashRouter }));
    };
    renderAtRoot(initalRoutingPaths);
    if (module.hot) {
        const apply = debounce(async () => {
            const routingPaths = (await import("./UI/RoutingPaths")).routingPaths;
            if (viewModelReattach)
                enableViewModelReattach();
            renderAtRoot(routingPaths);
            if (viewModelReattach)
                setTimeout(() => disableViewModelReattach(), 100);
        }, 500);
        module.hot.accept(["./UI/RoutingPaths"], async (_dependencies) => apply());
    }
})();
function checkSubdomainRedirect() {
    var _a, _b, _c;
    const subdomainRE = "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)";
    const env = new Environment();
    const webAppBaseUrl = env.WEBAPP_BASE_URL;
    const webRootDomain = env.WEB_ROOT_DOMAIN;
    const webRootDomainRE = webRootDomain.replace(/([:.])/g, "\\$1");
    const reStr = `(?<protocol>https?:\\/\\/)(?<subdomain>${subdomainRE}\\.(?<domain>${webRootDomainRE})(?<path>.*)(?<params>\\?.*)?`;
    const matches = new RegExp(reStr).exec(window.location.href);
    if (!matches)
        return false;
    const protocol = (_a = matches.groups) === null || _a === void 0 ? void 0 : _a.protocol;
    const subdomain = (_b = matches.groups) === null || _b === void 0 ? void 0 : _b.subdomain;
    const path = (_c = matches.groups) === null || _c === void 0 ? void 0 : _c.path.trim();
    if (!protocol || !subdomain || !path)
        return false;
    if (`${protocol}${subdomain}.${webRootDomain}` === webAppBaseUrl)
        return false;
    const check = path.replace(/^\/#?\/?/, "").replace(/\/$/, "");
    let redirectPath;
    if (check === "login-patients") {
        redirectPath = `/#/login-patients/${subdomain}`;
    }
    else if (check === "login") {
        redirectPath = `/#/login/${subdomain}`;
    }
    else {
        redirectPath = `/#/login-select/${subdomain}`;
    }
    window.location.replace(`${webAppBaseUrl}${redirectPath}`);
    return true;
}
async function checkValidEmbedIfNeeded(embedded, isSmartLaunch) {
    if (top === self) {
        return true;
    }
    if (isSmartLaunch) {
        return true;
    }
    if (!embedded) {
        console.error("Invalid embed");
        return false;
    }
    return true;
}
